<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<div class="add-edit-organization-app">
	<mat-tab-group class="add-edit-organization-tab-group">
		<mat-tab [label]="appStrings.ORG_TAB_INFO">
			<organization-app-info
				class="app-org-tab-content-container"
				[parentFormGroup]="orgApplicationFormGroup"
				[isAdding]="organizationService.isAdding$ | async"
			>
			</organization-app-info>
		</mat-tab>
		<mat-tab [label]="appStrings.ORG_TAB_PROJECTS">
			<organization-app-projects
				class="app-org-tab-content-container"
				[parentFormGroup]="orgApplicationFormGroup"
			>
			</organization-app-projects>
		</mat-tab>
	</mat-tab-group>

	<div class="button-container">
		<button-footer
			(buttonSaveOrClose)="handleItemEvent('Save')"
			[disabled]="!(canSave$ | async)"
			[saveOrCloseButtonText]="appStrings.UICONTROL_TEXT_SAVE | uppercase"
		>
			<button
				leftButton
				mat-button
				color="warn"
				[disabled]="!(canDelete$ | async)"
				(click)="handleItemEvent('Delete')"
			>
				{{ appStrings.UICONTROL_TEXT_DELETE | uppercase }}
			</button>
			<button middleButton mat-button color="primary" (click)="handleItemEvent('Cancel')">
				{{ appStrings.UICONTROL_TEXT_CANCEL | uppercase }}
			</button>
		</button-footer>
	</div>
</div>
